import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#14b8a6",
      contrastText: "#fff",
    },
    secondary: {
      main: "#99F6E4",
    },

    background: {
      default: "#e4e6ea",
      paper: "#ffffff",
    },

    text: {
      primary: "#71717A",
      secondary: "#374151",
      main: "#14b8a6",
      error: "#e2445c",
    },
  },
});

export default theme;
